import React from 'react';

import ApplicationTrackerImage from '../../assets/application_tracker.png';

const JobApplicationsTracker = () => {
  return (
    <>
    <style>{`
        @media (max-width: 768px) {
            .job-tracker-heading {
                font-size: 24px !important;
                margin-top: 1rem !important;
            }
            .job-tracker-label-mobile {
                margin-bottom: 0.5rem !important;
            }
            .job-tracker-paragraph-mobile {
                margin-top: 1rem !important;
            }
            .job-tracker-image-mobile {
                order: 1 !important;
                margin-bottom: 2rem !important;
                margin-top: -6rem !important;
                z-index: 10 !important;
                position: relative !important;
            }
            .job-tracker-content-mobile {
                order: 2 !important;
            }
            .job-tracker-button-mobile {
                margin-top: 1.5rem !important;
            }
        }
    `}</style>
    <section className="w-full  font-sans px-4 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center">
        {/* Left Content */}
        <div className="w-full md:w-1/2 pr-0 md:pr-12 mb-12 md:mb-0 job-tracker-content-mobile">
        <p className="job-tracker-label-mobile">Job Applications Tracker</p>
          <h2 className="text-4xl font-sans xs:mb-6 md:mb-12 job-tracker-heading">Save Jobs. Stay Organised. Manage Your job Search.</h2>
        <p className='xs:mb-6 md:mb-12 job-tracker-paragraph-mobile'>A faster, smarter way to stay on top of your job hunt. Easily track, bookmark, and organise opportunities from our job board, all in one place. Say goodbye to scattered tabs and missed deadlines.</p>
        <button className='bg-black text-white py-2 px-4 rounded-3xl job-tracker-button-mobile'
        onClick={() => {
          window.location.href = '/signup';
        }}
        >Start Organising Now</button>
        </div>
        
        {/* Right Image Section */}
        <div className="w-full md:w-1/2 bg-[#EFE8FF] rounded-3xl p-8 flex flex-col items-center justify-center job-tracker-image-mobile">
          {/* MCQ Illustration */}

          <img src={ApplicationTrackerImage} alt="Application Tracker" className='w-full h-full object-cover' />


        </div>
      </div>
    </section>
    </>
  );
};

export default JobApplicationsTracker;